import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { compose } from 'redux';
import { isEmpty } from 'ramda';

import store from '../../store';
import { membershipSettingsRestHooks } from '../../store/MembershipSettings/MembershipSettingsSlice';
import { useFetchStatus } from '../../utils/fetchStatusUtils';
import useMembershipSettings from '../../hooks/useMembershipSettings';

import MembershipSettingsTable from './components/MembershipSettingsTable';
import EditSettingModal from './components/EditSettingModal';

const MembershipSettingsContainer = () => {
  const {
    loadMembershipSettings,
    loadResetMembershipSettings,
    updateResetMembershipSetting,
    membershipSetting: { errors },
    membershipSettings: { loadingStatus, items },
  } = membershipSettingsRestHooks.use();

  const { updateSetting } = useMembershipSettings();
  const { isIdle } = useFetchStatus(loadingStatus);

  const [isEditDialogOpen, setEditDialogOpen] = useState(false);
  const [currentMembershipSetting, setСurrentMembershipSetting] = useState({});

  useEffect(() => {
    loadMembershipSettings();
    return () => {
      loadResetMembershipSettings();
    };
  }, []);

  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
    updateResetMembershipSetting();
  };
  const handleEditMembershipSetting = (setting) => {
    setEditDialogOpen(true);
    setСurrentMembershipSetting(setting);
  };

  const handleMembershipSettingUpdate = async (...params) => {
    return updateSetting(...params);
  };

  return (
    <div className="banner-settings">
      <div className="form-header">
        <h2>Membership Settings</h2>
      </div>
      <div>
        {!isEmpty(currentMembershipSetting) && (
          <EditSettingModal
            onEditDialogClose={handleEditDialogClose}
            isEditDialogOpen={isEditDialogOpen}
            currentMembershipSetting={currentMembershipSetting}
            onSubmit={handleMembershipSettingUpdate}
            apiErrors={errors}
          />
        )}
        {!isIdle && (
          <MembershipSettingsTable
            membershipSettings={items}
            loadingState={loadingStatus}
            onEditMembershipSetting={handleEditMembershipSetting}
          />
        )}
      </div>
    </div>
  );
};

const addStore = (ProxyComponent) => (props) =>
  (
    <Provider store={store}>
      <ProxyComponent {...props} />
    </Provider>
  );

export default compose(addStore)(MembershipSettingsContainer);
